import React, { useEffect, useState } from 'react'
import './courseDetail.css'
import { NavLink } from 'react-router-dom'
function CourseDetail() {
    const[loading,setLoading]=useState(true)

    useEffect(() => {
      const timer=setTimeout(()=>{
        setLoading(false);
      },2000);
    
      return () => {
        clearTimeout(timer)
      }
    }, [])
    
    return (
        <>
      {/* Loader */}
      {loading &&  <div className="loader-container">
        <div className="loader"></div>
        <img src="/images/logo192.png" alt="Anuyog Icon" className="loader-icon" />
      </div>  }


      {!loading && (
        <>
            <section className='consultancy-section'>
                <div className="consultancy">
                    <img src='/images/course_banner.jpg' alt="" />
                </div>
            </section>

            <section className='course-section mt-5 mb-5'>
                <h1 className='offering-title'><strong style={{ color: '#9D3B24', textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)' }}>Course Provided By anuyog Institute</strong></h1>
                <div className="container">
                    <div className="all-course mt-5 row">
                        <NavLink
                            to="/coursedetail"
                            onClick={() => window.scrollTo(0, 0)}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <div className="course col-md-4">
                                <div className="course-image">
                                    <img src="/images/course_banner.jpg" alt="" />
                                </div>
                                <div className="course-text">
                                    <h5 className='fw-bold'>DIPLOMA IN NATUROPATHY AND YOGA (NDDY)</h5>
                                    <h6 className='fw-bold'>Duration:3 years</h6>
                                    <NavLink
                                        to="/coursedetail"
                                        onClick={() => window.scrollTo(0, 0)}
                                        style={{ textDecoration: 'none', color: 'inherit' }}
                                    >
                                        <button type="button" className="btn">Read More</button>
                                    </NavLink>

                                </div>
                            </div>
                        </NavLink>
                    </div>
                </div>
            </section>


        </>
      )}
       </>
    )
}

export default CourseDetail
